var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxThinGrayOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.195 3.96322L7.5 6.98146L13.805 3.96322M7.5 13V6.97548M14 9.36616V4.5848C13.9997 4.37518 13.9329 4.1693 13.8061 3.98782C13.6793 3.80634 13.4971 3.65564 13.2778 3.55083L8.22222 1.16015C8.00264 1.05523 7.75355 1 7.5 1C7.24645 1 6.99736 1.05523 6.77778 1.16015L1.72222 3.55083C1.50286 3.65564 1.32065 3.80634 1.19389 3.98782C1.06713 4.1693 1.00026 4.37518 1 4.5848V9.36616C1.00026 9.57578 1.06713 9.78166 1.19389 9.96314C1.32065 10.1446 1.50286 10.2953 1.72222 10.4001L6.77778 12.7908C6.99736 12.8957 7.24645 12.951 7.5 12.951C7.75355 12.951 8.00264 12.8957 8.22222 12.7908L13.2778 10.4001C13.4971 10.2953 13.6793 10.1446 13.8061 9.96314C13.9329 9.78166 13.9997 9.57578 14 9.36616Z",
    stroke: "#9296AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxThinGrayOutline);
export default __webpack_public_path__ + "static/media/boxThinGrayOutline.7bea5d82e29c41a2bebf95b90607cab7.svg";
export { ForwardRef as ReactComponent };